import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http"
import { Observable } from 'rxjs';

import { environment } from "../../environments/environment";
import { UserAdminSend, UserSend } from "../models/user";
import { Profile } from "../models/profile";

@Injectable({
    providedIn: 'root'
})

export class UserService {

    constructor(private http: HttpClient) { }

    getList(params: any): Observable<any> {
        return this.http.get(`${environment.apiroot}/user`, { params });
    }

    getUser(id: String): Observable<any> {
        return this.http.get(`${environment.apiroot}/user/${id}`);
    }

    patchUser(user: UserSend): Observable<any> {
        const id = user.id
        delete user.id;
        return this.http.patch(`${environment.apiroot}/user/${id}`, user);
    }

    addBagsUser(id: string, listBags: string[]): Observable<any> {
        const payload = { mainAccounts: listBags };
        return this.http.patch(`${environment.apiroot}/user/${id}/assign`, payload);
    }

    getMine(): Observable<any> {
        return this.http.get(`${environment.apiroot}/user/mine`);
    }

    patchProfile(id: string, profile: Profile): Observable<any> {
        return this.http.patch(`${environment.apiroot}/user/profile/${id}`, profile);
    }

    // Obtener Usuario Administrativo - GET
    getUserAdmin(id: string): Observable<any> {
        return this.http.get(`${environment.apiroot}/user/admin/account/${id}`)
    }

    // Crear Usuario Administrativo - POST
    postUserAdmin(id: string, userAdmin: UserAdminSend): Observable<any> {
        console.log('entre aca')
        return this.http.post(`${environment.apiroot}/user/admin/account/${id}`, userAdmin)
    }

    patchUserAdmin(id: string, userAdmin: UserAdminSend): Observable<any> {
        return this.http.patch(`${environment.apiroot}/user/admin/${id}`, userAdmin)
    }

}